import FavoriteIcon, { SMALL, MEDIUM, LARGE } from "./FavoriteIcon";

export default FavoriteIcon;
export { SMALL, MEDIUM, LARGE };
